import { mapActions } from 'vuex'

const progresModlaCommands = {
  methods: {
    ...mapActions('progressModal', {
      showProgressModalInternal: 'showProgressModal',
      hideProgressModalInternal: 'hideProgressModal'
    }),
    showProgressModal (message = {}) {
      this.showProgressModalInternal(message)
    },
    hideProgressModal () {
      this.hideProgressModalInternal()
    }
  }
}

export default progresModlaCommands
